import { AbilityBuilder, MongoAbility, createMongoAbility } from '@casl/ability';

import { tenantContextPermissions } from './tenant-context-permissions';

import { UserRole } from '@/types/user-role';

type CRUD = 'create' | 'read' | 'update' | 'delete';
type CRUD_SUBJECTS =
  | 'AccessControlEvents'
  | 'AccessControlProfiles'
  | 'GDPR'
  | 'DefaultSettings'
  | 'OrganizationLogo';

interface Administrator {
  userId?: string;
  role?: UserRole;
  selectedRole?: UserRole;
}

type AdministratorsAbilities = [CRUD, 'Administrators' | Administrator];

type VisitorsActions = CRUD | 'downloadDiscountTicketsRaport' | 'applyDiscount' | 'extendVisit';

type VisitorsAbilities = [VisitorsActions, 'Visitors'];

type HostsActions =
  | CRUD
  | 'allowedInviteToParking'
  | 'manageDestinations'
  | 'manageDestinationGroup'
  | 'manageBillingGroup'
  | 'manageDiscount';

type HostsAbilities = [HostsActions, 'Hosts'];

type BillingGroupsActions = CRUD | 'manageParkingDiscounts';

type BillingGroupsAbilities = [BillingGroupsActions, 'BillingGroups'];

type DestinationsGroupsActions = CRUD | 'manageDefaultGroup' | 'manageGroupDestinations';

type DestinationsGroupsAbilities = [DestinationsGroupsActions, 'DestinationsGroups'];

type DestinationsActions = CRUD | 'manageAccessControlProfiles';

type DestinationsAbilities = [DestinationsActions, 'Destinations'];

type Abilities = [CRUD, CRUD_SUBJECTS];

export type AppAbility = MongoAbility<
  | Abilities
  | AdministratorsAbilities
  | VisitorsAbilities
  | HostsAbilities
  | BillingGroupsAbilities
  | DestinationsGroupsAbilities
  | DestinationsAbilities
>;

export type Role = 'owner' | 'admin' | 'master';

export function definePermissions(role: Role, userId: string, isSSO: boolean) {
  const builder = new AbilityBuilder<AppAbility>(createMongoAbility);

  tenantContextPermissions(builder, role, userId, isSSO);

  return builder.build();
}
